import { jsxs as _jsxs } from "react/jsx-runtime";
const CSS = `
.cg-btn {
  --_bg: var(--brand-primary);
  --_bg-hover: var(--brand-primary-hover);
  --_fg: var(--brand-on-primary);
  --_border: transparent;
  display: inline-flex; align-items: center; justify-content: center; gap: var(--space-2);
  font-family: var(--font-sans); font-weight: var(--weight-semibold);
  border: 1px solid var(--_border); border-radius: var(--radius-md);
  background: var(--_bg); color: var(--_fg);
  cursor: pointer; white-space: nowrap; text-decoration: none;
  transition: background var(--duration-fast) var(--ease-standard),
              box-shadow var(--duration-fast) var(--ease-standard),
              transform var(--duration-fast) var(--ease-standard),
              border-color var(--duration-fast) var(--ease-standard);
}
.cg-btn:hover { background: var(--_bg-hover); }
.cg-btn:active { transform: translateY(1px); }
.cg-btn:focus-visible { outline: none; box-shadow: var(--shadow-focus); }
.cg-btn:disabled, .cg-btn[aria-disabled="true"] { opacity: .55; cursor: not-allowed; transform: none; }
.cg-btn svg { width: 1.1em; height: 1.1em; flex-shrink: 0; }
.cg-btn--sm { height: var(--control-h-sm); padding: 0 var(--space-3); font-size: var(--text-xs); }
.cg-btn--md { height: var(--control-h-md); padding: 0 var(--space-4); font-size: var(--text-base); }
.cg-btn--lg { height: var(--control-h-lg); padding: 0 var(--space-5); font-size: var(--text-md); }
.cg-btn--block { width: 100%; }
.cg-btn--secondary {
  --_bg: var(--surface-card); --_bg-hover: var(--slate-50);
  --_fg: var(--text-body); --_border: var(--border-strong);
}
.cg-btn--ghost {
  --_bg: transparent; --_bg-hover: var(--slate-100); --_fg: var(--text-body);
}
.cg-btn--soft {
  --_bg: var(--brand-primary-soft); --_bg-hover: var(--azure-100); --_fg: var(--brand-on-soft);
}
.cg-btn--success { --_bg: var(--green-500); --_bg-hover: var(--green-600); --_fg:#fff; }
.cg-btn--danger  { --_bg: var(--red-500);  --_bg-hover: var(--red-600);  --_fg:#fff; }
`;
function injectStyles() {
    if (typeof document !== 'undefined' && !document.getElementById('cg-button-css')) {
        const s = document.createElement('style');
        s.id = 'cg-button-css';
        s.textContent = CSS;
        document.head.appendChild(s);
    }
}
export function Button({ variant = 'primary', size = 'md', block = false, leftIcon, rightIcon, disabled, as: Tag = 'button', className = '', children, ...rest }) {
    injectStyles();
    const cls = [
        'cg-btn',
        `cg-btn--${variant}`,
        `cg-btn--${size}`,
        block ? 'cg-btn--block' : '',
        className,
    ].filter(Boolean).join(' ');
    return (_jsxs(Tag, { className: cls, disabled: Tag === 'button' ? disabled : undefined, "aria-disabled": disabled || undefined, ...rest, children: [leftIcon, children, rightIcon] }));
}
